import { render, staticRenderFns } from "./TermsOfServiceEnglish.vue?vue&type=template&id=5b3a5820"
import script from "./TermsOfServiceEnglish.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceEnglish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports